import { btsTimeline } from '@/mocks/home';

export default function BehindScenes() {
  return (
    <section id="bts" className="w-full px-4 md:px-8 py-14 md:py-20 bg-background-950">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 md:gap-10">
          <div className="lg:col-span-1">
            <div className="reveal lg:sticky lg:top-24">
              <span className="text-accent-400 font-label text-sm tracking-wide">幕后花絮</span>
              <h2 className="mt-2 font-heading text-2xl md:text-4xl font-bold text-background-50">
                一部 3D 版是怎么被推上台的
              </h2>
              <p className="mt-4 text-background-50/70 text-sm md:text-base leading-relaxed">
                从蹭热度的立项，到靠外援和 3D 制造话题，再到上映后的口碑走向，这条时间线把幕后故事串了起来。
              </p>
              <div className="mt-6 rounded-lg overflow-hidden h-[200px] md:h-[240px]">
                <img
                  src="https://readdy.ai/api/search-image?query=Abstract%20film%20production%20scene%20with%20vintage%20clapperboard%2C%20camera%20rig%20and%20warm%20studio%20lighting%20in%20amber%20and%20peach%20tones%2C%20soft%20focus%20background%2C%20grainy%20analog%20texture%2C%20cinematic%20behind%20the%20scenes%20mood%2C%20no%20text&width=1000&height=750&seq=peach-bts-01&orientation=landscape"
                  alt="抽象的片场氛围，呼应 3D 版的幕后制作过程"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>

          <div className="lg:col-span-2">
            <ol className="relative border-l border-background-800 ml-2 space-y-6 md:space-y-8">
              {btsTimeline.map((item, index) => (
                <li
                  key={item.step}
                  className="reveal pl-6 md:pl-8 relative"
                  style={{ animationDelay: `${index * 70}ms` }}
                >
                  <span className="absolute -left-[13px] top-1 w-6 h-6 flex items-center justify-center rounded-full bg-accent-500 text-foreground-950 text-[11px] font-label font-bold">
                    {item.step}
                  </span>
                  <h3 className="font-heading text-lg md:text-xl font-bold text-background-50">
                    {item.title}
                  </h3>
                  <p className="mt-2 text-background-50/70 text-sm md:text-base leading-relaxed">
                    {item.desc}
                  </p>
                </li>
              ))}
            </ol>
          </div>
        </div>
      </div>
    </section>
  );
}